exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.md-accent .md-primary[data-v-6843e7a6] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 0 auto;\n          flex: 1 0 auto;\n  color: #578AD6 !important;\n}\n.md-accent .md-primary.md-button:not([disabled]).md-focused[data-v-6843e7a6]:before, .md-accent .md-primary.md-button[data-v-6843e7a6]:not([disabled]):active:before, .md-accent .md-primary.md-button[data-v-6843e7a6]:not([disabled]):hover:before {\n    background-color: currentColor !important;\n    opacity: .12;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6843e7a6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/common/messages/Snackbar.vue
// module id = 5T+l
// module chunks = 1